module.exports = __webpack_public_path__ + "img/B10.248a8f1c.png";